import * as fromCollections from '../reducers/museum-collections.reducer';
import { ActionReducerMap, createFeatureSelector, MetaReducer } from '@ngrx/store';
import { environment } from '../../../../environments/environment';

export const featureKey = 'museum';

export interface ContentState {
  collections: fromCollections.MuseumCollectionsState;
}

export const reducers: ActionReducerMap<ContentState> = {
  collections: fromCollections.MuseumCollectionReducer,
};

export const getMuseumState = createFeatureSelector<ContentState>(featureKey);

export const metaReducers: MetaReducer<ContentState>[] = !environment.production ? [] : [];
